import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
const ActionDropDownNew = (props) => {
  const employeeData = useSelector((state) => state.user);
  const isMeetingOrganiser =
    props?.actionDetails?.meetingDetail?.createdById?.toString() ===
    employeeData?.userData?._id?.toString()
      ? true
      : false;
  return (
    <>
      {props?.actionDetails.isAction === true &&
      props?.actionDetails?.isCancelled === false &&
      employeeData.userData.isAdmin === true ? (
        <Dropdown>
          <Dropdown.Toggle>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#000"
              className="bi bi-three-dots-vertical"
              viewBox="0 0 16 16"
            >
              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
            </svg>
          </Dropdown.Toggle>

          <Dropdown.Menu
            placementClass="bottom-end-placement"
            className="dropdown-menu-end1"
          >
            <>
              {props?.actionDetails?.isReopened === false &&
              employeeData.userData.isAdmin === true &&
              props?.actionDetails?.isApproved === false &&
              props?.actionDetails?.isComplete === true ? (
                <Link
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                >
                  <Dropdown.Item
                    href="#/action-2"
                    onClick={() => {
                      props.handleReopenActionModal();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      fill="currentColor"
                      className="bi bi-arrow-clockwise me-2"
                      viewBox="0 0 19 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                      />
                      <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                    </svg>
                    Reopen
                  </Dropdown.Item>
                </Link>
              ) : null}
              {employeeData.userData.isAdmin === true &&
              props?.actionDetails?.isApproved === false &&
              props?.actionDetails?.isComplete == true ? (
                <Link
                  to=""
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                >
                  <Dropdown.Item
                    href="#/action-2"
                    onClick={() => {
                      props.handleApproveActionModal();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-check2-square me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5z" />
                      <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0" />
                    </svg>
                    Approve
                  </Dropdown.Item>
                </Link>
              ) : null}
              {/* {props?.actionDetails?.isApproved === false &&
                            props?.actionDetails?.isComplete === false && props.actionDetails.reassigneRequestDetails ? (
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                }}
                            >
                                <Dropdown.Item
                                    href="#/action-2"
                                    onClick={() => {
                                        props.handleReassignModal(props?.actionDetails?._id);
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-arrow-repeat me-2"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" />
                                        <path
                                            fill-rule="evenodd"
                                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
                                        />
                                    </svg>
                                    Forward
                                </Dropdown.Item>
                            </Link>
                        ) : null} */}
              {props?.actionDetails?.isApproved === false &&
              props?.actionDetails?.isComplete === false &&
              props?.actionDetails?.isCancelled === false &&
              // (Array.isArray(props?.actionDetails?.reassigneRequestDetails) &&
              props.actionDetails.reassigneRequestDetails.length === 0 ? (
                <Link
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                >
                  <Dropdown.Item
                    href="#/action-2"
                    onClick={() => {
                      props.handleReassignModal(props?.actionDetails?._id);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-repeat me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" />
                      <path
                        fillRule="evenodd"
                        d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
                      />
                    </svg>
                    Forward
                  </Dropdown.Item>
                </Link>
              ) : null}

              {/* <hr className="dropdown-divider" role="separator" /> */}
              {/*             
              <Link
                to=""
                style={{
                  textDecoration: "none",
                  color: "black",
                }}
              >
                <Dropdown.Item
                  className="delete-drp"
                  href="#/action-2"
                  onClick={() => {
                    props.handleCancelActionModal();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    className="bi bi-x-circle me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"></path>
                  </svg>
                  Cancel
                </Dropdown.Item>
              </Link> */}
              {props?.actionDetails?.isApproved === false &&
              props?.actionDetails?.isComplete === false ? (
                <Link
                  to=""
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                >
                  <Dropdown.Item
                    className="delete-drp"
                    href="#/action-2"
                    onClick={() => {
                      props.handleCancelActionModal();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-x-circle me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"></path>
                    </svg>
                    Cancel
                  </Dropdown.Item>
                </Link>
              ) : null}
            </>
          </Dropdown.Menu>
        </Dropdown>
      ) : null}
    </>
  );
};

export default ActionDropDownNew;
